import { authServiceUrl } from "services/http";

export const authServiceEndpoints = {
  resetPassword: `${authServiceUrl}/reset`,
  generateOtp: `${authServiceUrl}/generateOtp`,
  validateOtp: `${authServiceUrl}/validateOtp`,
  resetPasswordWithOtp: `${authServiceUrl}/reset/password/otp`,

  getUser: `${authServiceUrl}/employeeData/getAllActiveEmployeeData`,
  createUser: `${authServiceUrl}/users/register`,
  updateUser: `${authServiceUrl}/users/updateUser`,
  searchProfile: `${authServiceUrl}/searchUserProfile`,
  getProfileById: `${authServiceUrl}/getUserProfileDetails`,
  getUserByEmployeeId: `${authServiceUrl}/getUserProfileDetailsByEmployeeId`,
  getTicketHistory: `${authServiceUrl}/users/ticket/getAllTickets`,
  requestResetPassword: `${authServiceUrl}/user/resetPassword/ticket`,
  getEmployeeDetails: `${authServiceUrl}/employeeData/getEmployeeDetailsByEmployeeId`,
  updateEmployee: `${authServiceUrl}/employeeData/updateEmployeeDetails`,
  exportExcel: `${authServiceUrl}/exportExcel`,
  getAllUserByUserKeyList: `${authServiceUrl}/users/getAllUserByUserKeyList`,

  getEmployeeCountDetails: `${authServiceUrl}/employeeData/getEmployeeCountDetails`,
  searchEmployeeDetails: `${authServiceUrl}/employeeData/searchEmployeeDetails`,
  getEmployeeDetailLogs: `${authServiceUrl}/audit/getEmployeeDetailLogs`,
  searchEmployeeDataToCsv: `${authServiceUrl}/employeeData/searchEmployeeDataToCsv`,

  searchBulkUploadStatus: `${authServiceUrl}/users/searchBulkUploadStatus`,
  validateGoogleSSOToken: `${authServiceUrl}/validateGoogleSSOToken`,
    honoMapping:{
    department:`${authServiceUrl}/employeeData/getAllHonoDepartmentValue`,
    jobTitle:`${authServiceUrl}/employeeData/getAllHonoDesignationValue`,
    region:`${authServiceUrl}/employeeData/getAllHonoRegionValue`
  },
  regionMapping:{
    search:`${authServiceUrl}/regionHonoMapping/searchRegionHonoMapping`,
    create:`${authServiceUrl}/regionHonoMapping/createRegionHonoMapping`,
    update:`${authServiceUrl}/regionHonoMapping/updateRegionHonoMapping`,
    delete:`${authServiceUrl}/regionHonoMapping/deleteRegionHonoMapping`,
  },
    jobTitleMapping:{
    search:`${authServiceUrl}/jobTitleHonoMapping/searchJobTitleHonoMapping`,
    create:`${authServiceUrl}/jobTitleHonoMapping/createJobTitleHonoMapping`,
    update:`${authServiceUrl}/jobTitleHonoMapping/updateJobTitleHonoMapping`,
    delete:`${authServiceUrl}/jobTitleHonoMapping/deleteJobTitleHonoMapping`,
  },
    departmentMapping:{
    search:`${authServiceUrl}/departmentHonoMapping/searchDepartmentHonoMapping`,
    create:`${authServiceUrl}/departmentHonoMapping/createDepartmentHonoMapping`,
    update:`${authServiceUrl}/departmentHonoMapping/updateDepartmentHonoMapping`,
    delete:`${authServiceUrl}/departmentHonoMapping/deleteDepartmentHonoMapping`,
  },
  getEmployeeDetailLogs: `${authServiceUrl}/audit/getEmployeeDetailLogs`,
};
